import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ShareOfferPreviewResolver } from '../core/share-offer-preview.resolver';
import { StepsComponent } from './steps.component';

const StepsRoutes: Routes = [
  {
    path: '',
    component: StepsComponent,
    children: [
      {
        path: 'where-to-install-charger',
        loadChildren: () =>
          import('@theia-cc/em/steps/where-to-install-charger').then(
            m => m.WhereToInstallChargerModule
          ),
      },
      {
        path: 'number-of-parkingspaces-to-be-equipped-residential',
        loadChildren: () =>
          import('@theia-cc/em/steps/number-of-parkingspaces-to-be-equipped-residential').then(
            m => m.NumberOfParkingspacesToBeEquippedResidentialModule
          ),
      },
      {
        path: 'parkingspace',
        loadChildren: () =>
          import('@theia-cc/em/steps/parking-space').then(m => m.ParkingSpaceModule),
      },
      {
        path: 'poweroutlet',
        loadChildren: () =>
          import('@theia-cc/em/steps/power-outlet').then(m => m.PowerOutletModule),
      },
      {
        path: 'fusebox',
        loadChildren: () => import('@theia-cc/em/steps/fusebox').then(m => m.FuseboxModule),
      },
      {
        path: 'connectpv',
        loadChildren: () => import('@theia-cc/em/steps/connect-pv').then(m => m.ConnectPvModule),
      },
      {
        path: 'offerpreview',
        loadChildren: () =>
          import('@theia-cc/em/steps/offer-preview').then(m => m.OfferPreviewModule),
        resolve: {
          templateSelected: ShareOfferPreviewResolver,
        },
      },
      {
        path: 'parking-space-arrangement',
        loadChildren: () =>
          import('@theia-cc/em/steps/parking-space-arrangement').then(
            m => m.ParkingSpaceArrangementModule
          ),
      },
      {
        path: 'contact-email',
        loadChildren: () =>
          import('@theia-cc/em/steps/contact-email').then(m => m.ContactEmailModule),
      },
      {
        path: 'contact-condensed',
        loadChildren: () =>
          import('@theia-cc/em/steps/contact-condensed').then(m => m.ContactCondensedModule),
      },
      // legacy routes in case if it still used somewhere outside EM CC
      {
        path: 'offerpreview-tcs',
        redirectTo: 'offerpreview',
      },
      {
        path: 'offerpreview-renault',
        redirectTo: 'offerpreview',
      },
      {
        path: 'offerpreview-newmotion',
        redirectTo: 'offerpreview',
      },
      {
        path: 'offerpreview-honda',
        redirectTo: 'offerpreview',
      },
      {
        path: ' offerpreview-eaton',
        redirectTo: 'offerpreview',
      },
      {
        path: 'offerpreview-amag',
        redirectTo: 'offerpreview',
      },

      {
        path: 'contact',
        loadChildren: () =>
          import('@theia-cc/em/steps/contact-form').then(m => m.ContactFormModule),
      },
      {
        path: 'contact-dealer',
        loadChildren: () =>
          import('@theia-cc/em/steps/contact-form').then(m => m.ContactFormModule),
        data: { dealer: true },
      },
      {
        path: 'number-of-parkingspaces',
        loadChildren: () =>
          import('@theia-cc/em/steps/number-of-parking-spaces').then(
            m => m.NumberOfParkingSpacesModule
          ),
      },
      {
        path: 'distance-fusebox-to-chargingstation',
        loadChildren: () =>
          import('@theia-cc/em/steps/distance-fusebox-to-charging-station').then(
            m => m.DistanceFuseboxToChargingStationModule
          ),
      },
      { path: '', redirectTo: 'where-to-install-charger', pathMatch: 'full' },
      { path: '**', redirectTo: '/where-to-install-charger', pathMatch: 'full' },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(StepsRoutes)],
  providers: [],
  exports: [RouterModule],
})
export class StepsRoutingModule {}
